
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
//import { useGlobalStore } from "@/stores/global";
import EnterButton from "@/components/EnterButton.vue";
import Modal from "@/components/Modal.vue";
import PickupModal from "@/components/PickupModal.vue";
import marked from "marked";
import termMd from "@/assets/term.md";
import AppConst from "@/consts/app-const.ts";

/**
 *
 */
export default defineComponent({
  name: "Top",
  components: {
    EnterButton,
    Modal,
    PickupModal,
  },
  props: {},
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });

    // NOTE: 対象画像名は連番である必要あり
    //const pickupNoMin = 1;
    const pickupNoMax = 8; // XXX: 対象数に応じて値変更
    const pickupDetailImgSrc = ref<String>("");

    const showPickupDetailModal = ref<Boolean>(false);
    const showTermModal = ref<Boolean>(false);
    const canClickEntryBtn = ref<Boolean>(false);

    const term = marked(termMd);

    onMounted(() => {});

    onUnmounted(() => {});

    function onClickEntryBtn() {
      toSelect();
    }

    function openPickupDetailModal(pickupNo) {
      showPickupDetailModal.value = true;
      pickupDetailImgSrc.value = pickupImgSrc(pickupNo);
    }

    function closePickupDetailModal() {
      showPickupDetailModal.value = false;
    }

    function pickupImgSrc(pickupNo: number) {
      return "/app/assets/img/top_pickup/pickup_" + pickupNo + ".png";
    }

    function openTermModal() {
      showTermModal.value = true;
    }

    function closeTermModal() {
      showTermModal.value = false;
    }

    return {
      pickupNoMax,
      pickupImgSrc,
      pickupDetailImgSrc,
      onClickEntryBtn,
      openPickupDetailModal,
      closePickupDetailModal,
      showPickupDetailModal,
      canClickEntryBtn,
      openTermModal,
      closeTermModal,
      showTermModal,
      term,
      AppConst,
    };
  },
});
